import GoldBows from "./Bows/Gold";
import PurpleBows from "./Bows/Purple";
import OtherBows from "./Bows/Others";
import GoldCatalyst from "./Catalysts/Gold";
import PurpleCatalysts from "./Catalysts/Purple";
import OtherCatalysts from "./Catalysts/Others";
import GoldClaymores from "./Claymores/Gold";
import PurpleClaymores from "./Claymores/Purple";
import OtherClaymores from "./Claymores/Others";
import GoldPolearms from "./Polearms/Gold";
import PurplePolearms from "./Polearms/Purple";
import OtherPolearms from "./Polearms/Others";
import GoldSwords from "./Swords/Gold";
import PurpleSwords from "./Swords/Purple";
import OtherSwords from "./Swords/Others";

// total 143
const weapons = {
  Bow: GoldBows.concat(PurpleBows, OtherBows),
  Catalyst: GoldCatalyst.concat(PurpleCatalysts, OtherCatalysts),
  Claymore: GoldClaymores.concat(PurpleClaymores, OtherClaymores),
  Polearm: GoldPolearms.concat(PurplePolearms, OtherPolearms),
  Sword: GoldSwords.concat(PurpleSwords, OtherSwords)
};

export default weapons;
